<template>
  <div class="content">
    <div class="header_top">
      <div style="position: relative">
        <a-input-search
          v-model="activeName"
          placeholder="请输入活动名称"
          style="width: 240px"
          @search="reGetActiveList"
        />
        <a-select
          default-value="-1"
          style="width: 240px; margin-left: 16px"
          v-model="status"
          @change="reGetActiveList"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option value="">活动状态</a-select-option>
          <a-select-option value="0">未开始</a-select-option>
          <a-select-option value="1">进行中</a-select-option>
          <a-select-option value="2">已结束</a-select-option>
        </a-select>
      </div>
      <div>
        <a-button
          type="primary"
          class="add_course_btn ZHIHUISHU_QZMD add_active_btn"
          @click="
            handleActivityModal({ showModal: true, option: 'create', activityItem: { activityType: 2, watchVideo: 1 } })
          "
        >
          <a-icon type="plus-circle" theme="filled" />
          创建活动
        </a-button>
      </div>
    </div>
    <div class="count_box">
      <div>
        活动数：
        <span>{{ totalCount || 0 }}</span>
      </div>
    </div>
    <div class="list_content">
      <a-table
        :columns="columns"
        :data-source="activeList"
        :pagination="false"
        :customRow="handleRowEvent"
        :row-key="(record, index) => record.id"
        :loading="tabLoading"
      >
        <template slot="status" slot-scope="text, record">
          <a-tag :color="record.status | filterActiveListStatusTag">
            {{ text | filterActiveListStatusTagForText }}
          </a-tag>
        </template>
        <template slot="activityName" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">{{ text }}</span>
        </template>
        <template slot="progress" slot-scope="text, record">
          <div v-if="text">
            <span :class="record.status == '2' ? 'end_gray' : ''" v-if="record.status == '2'">
              {{ text }}
            </span>
            <div v-else>
              <span class="count_box_color">{{ (text || '').split('/')[0] || '' }}</span>
              <span>
                {{ (text || '').split('/')[1] ? '/' + (text || '').split('/')[1] : '' }}
              </span>
            </div>
          </div>
          <div v-else>- -</div>
        </template>
        <template slot="startTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">
            {{ text ? text.replaceAll('-', '/') : '- -' }}
          </span>
        </template>
        <template slot="endTime" slot-scope="text, record">
          <span :class="record.status == '2' ? 'end_gray' : ''">
            {{ text ? text.replaceAll('-', '/') : '- -' }}
          </span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">编辑</template>
            <a-icon
              type="edit"
              class="icon_edit"
              @click.prevent.stop="handleActivityModal({ showModal: true, option: 'edit', activityItem: record })"
            />
          </a-tooltip>
          <a-tooltip>
            <template slot="title">删除</template>
            <img
              @click.prevent.stop="showDeleteConfirm(record)"
              style="width: 20px; height: 20px; cursor: pointer"
              src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202112/b2b0fcd1a994443dbb8f1a1c05a34b04.png"
              alt=""
            />
          </a-tooltip>
        </template>
      </a-table>
      <a-row
        type="flex"
        justify="end"
        style="margin-top: 16px; padding-bottom: 32px; padding-right: 16px; position: relative"
      >
        <a-pagination
          show-size-changer
          :default-current="1"
          :page-size-options="pageSizeOptions"
          :total="totalCount"
          :defaultPageSize="50"
          @change="handlePageChange"
          @showSizeChange="onShowSizeChange"
          v-model="pageNum"
          :pageSize.sync="pageSize"
          :show-total="(total) => `共 ${total} 条`"
          style="position: relative"
        />
      </a-row>
    </div>
    <active-modal
      :activityModalData="activityModalData"
      :activityItem="curActivityItem"
      @refresh="reGetActiveList"
      @close="handleActivityModal({ showModal: false })"
    ></active-modal>

    <my-dialog @hideMask="dialogFlagForDelete = false" :dialogFlag="dialogFlagForDelete" width="330px" p_lr="0">
      <div class="dialog_inner_container_for_delete">
        <div class="dialog_inner_container_for_delete_header">提示</div>
        <div class="dialog_inner_container_for_delete_body">活动删除后无法恢复，请谨慎操作</div>
        <div class="dialog_inner_container_for_delete_footer">
          <div
            :class="[
              'dialog_inner_container_for_delete_footer_inner_item',
              'ZHIHUISHU_QZMD',
              index === 1 ? 'm_l15' : ''
            ]"
            v-for="(item, index) in deleteOperationList"
            :key="item.title"
            :style="{
              backgroundColor: item.bgc,
              border: item.border,
              color: item.color
            }"
            @click="deleteOperationItemClick(item)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="loading_mask" v-if="dialogLoadingForDelete">
          <a-spin />
        </div>
      </div>
    </my-dialog>
  </div>
</template>

<script>
const columns = [
  {
    title: '状态',
    width: 120,
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '活动名称',
    // align: 'center',
    dataIndex: 'activityName',
    scopedSlots: { customRender: 'activityName' }
  },
  {
    title: '活动进度',
    // width: 88,
    // minWidth: 88,
    dataIndex: 'progress',
    scopedSlots: { customRender: 'progress' }
  },
  {
    title: '活动开始时间',
    // width: 145,
    dataIndex: 'startTime',
    scopedSlots: { customRender: 'startTime' }
  },
  {
    title: '活动结束时间',
    // width: 145,
    dataIndex: 'endTime',
    scopedSlots: { customRender: 'endTime' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 120,
    scopedSlots: { customRender: 'action' },
    align: 'right'
  }
]
export default {
  components: {
    'my-dialog': () => import('../../components/my_dialog'),
    'active-modal': () => import('../../components/activeModal/index')
  },
  data() {
    return {
      activeModalTitle: '创建活动',
      activeModalData: {},
      activityModalData: {},
      curActivityItem: {}, // 创建活动时默认
      handleRowEvent: (record, index) => ({
        on: {
          click: () => {
            const { activityType } = record
            this.$router.push({
              name: activityType === 2 ? 'ActiveListDetailSpoc' : 'ActiveListDetail',
              query: {
                id: record.id
              }
            })
            //点击行要做的操作
          }
        }
      }),
      activeName: '',
      status: '',
      showModal: false,
      columns,
      activeList: [],
      totalCount: 0,
      tabLoading: false,
      pageNum: 1,
      pageSize: 50,
      dialogFlagForDelete: false,
      deleteData: [],
      deleteOperationList: [
        {
          title: '确定删除',
          bgc: '#FFF',
          border: '1px solid #D9D9D9',
          color: '#595959',
          type: 0
        },
        {
          title: '取消删除',
          bgc: '#5f60d3',
          border: 'none',
          color: '#FFF',
          type: 1
        }
      ],
      dialogLoadingForDelete: false,
      pageSizeOptions: ['50', '100', '150', '200']
    }
  },
  filters: {
    filterActiveListStatusTag(liveStatus) {
      let res = 'blue'
      switch (String(liveStatus)) {
        case '0':
          res = 'blue'
          break
        case '1':
          res = 'green'
          break
        case '2':
          res = 'orange'
          break
      }
      return res
    },
    filterActiveListStatusTagForText(liveStatus) {
      let res = '未开始'
      switch (String(liveStatus)) {
        case '0':
          res = '未开始'
          break
        case '1':
          res = '进行中'
          break
        case '2':
          res = '已结束'
          break
      }
      return res
    }
  },
  mounted() {
    this.getActiveList()
  },
  activated() {
    this.getActiveList()
  },
  methods: {
    handleActivityModal(obj = {}) {
      const { showModal, option, activityItem = {} } = obj
      if (showModal) {
        this.activityModalData = {
          showModal,
          option,
          isEdit: option === 'edit',
          modalTitle: option === 'edit' ? '编辑活动' : '创建活动',
          activityItem
        }
      } else {
        this.activityModalData = {
          ...this.activityModalData,
          showModal
        }
      }
      this.curActivityItem = activityItem
    },
    async getActiveList() {
      this.tabLoading = true
      let res = await this.$http.getActiveList({
        activityName: this.activeName,
        activityStatus: this.status,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      this.tabLoading = false
      if (res.code !== 200) {
        this.$message.error(res.msg || '请求活动列表失败！')
        return
      }
      this.activeList = res.rt.list
      this.totalCount = res.rt.totalCount
    },
    reGetActiveList() {
      this.pageNum = 1
      this.getActiveList()
    },
    handlePageChange(page, pageSize) {
      this.pageNum = page
      this.pageSize = pageSize
      this.getActiveList()
    },
    onShowSizeChange(current, size) {
      this.pageNum = current
      this.pageSize = size
      this.getActiveList()
    },
    showDeleteConfirm(data) {
      this.dialogFlagForDelete = true
      this.deleteData = data
    },
    async deleteOperationItemClick({ type }) {
      const { totalCount, pageSize, pageNum } = this
      switch (type) {
        case 0:
          try {
            this.dialogLoadingForDelete = true
            let result = await this.$http.deleteActivity({
              activityId: this.deleteData.id
            })
            this.dialogLoadingForDelete = false
            if (result.code !== 200) return this.$message.error(result.msg)
            let { rt: resultReally } = result
            if (resultReally.resultStatus !== 1)
              return this.$message.error(resultReally.resultMessage ? resultReally.resultMessage : '删除失败')
            this.$message.success('删除成功')
            this.dialogFlagForDelete = false

            const totalPage = Math.ceil(totalCount / pageSize)
            const isLastOne = (totalCount - 1) % pageSize === 0
            if (pageNum > 1 && isLastOne && pageNum === totalPage) {
              this.pageNum = pageNum - 1
            }

            this.getActiveList()
          } catch (err) {
            console.log(err)
          }
          break
        case 1:
          this.dialogFlagForDelete = false
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin dialogTitle($color) {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-weight: bold;
  color: $color;
  font-size: 16px;
  border-radius: 10px 10px 0 0;
  padding: 0 30px;
  border-bottom: 1px solid #e7e7e7;
}
@mixin verticalAndCrosswiseCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes scaleCircle {
  from {
    transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(100);
  }
}

.content {
  min-width: 1280px;
  .header_top {
    background-color: #fff !important;
    box-shadow: 0 0 10px #ddd;
    padding: 19px 16px;
    display: flex;
    justify-content: space-between;
    .add_active_btn {
      background: #5f60d3;
      border-radius: 2px;
      height: 38px;
      width: 112px;
      border: none;
    }
  }
  ::v-deep {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      border-bottom: 0;
    }
    .ant-table-thead > tr > th {
      background: #f6f6f6;
    }
    .ant-table-tbody {
      tr:nth-child(even) {
        background: #f4f7fa;
      }
      .ant-table-row {
        cursor: pointer;
      }
    }
    .action {
      text-align: center;
      .action-icon {
        cursor: pointer;
      }
    }
    .ant-table-pagination {
      float: none;
      text-align: center;
    }
  }
  .list_content {
    min-height: 996px;
    text-align: left;
    background: #fff;
    box-shadow: 0 0 10px #ddd;
    border-radius: 10px;
    padding-bottom: 16px;
  }
  .count_box {
    height: 60px;
    line-height: 60px;
    display: flex;
    > div {
      margin-right: 15px;
      > span {
        color: #5f60d3;
        font-weight: bold;
      }
    }
  }
  .end_gray {
    color: #bfbfbf;
  }
  .count_box_color {
    color: #5f60d3;
    font-weight: bold;
    font-size: 16px;
  }
  .dialog_inner_container_for_delete {
    .dialog_inner_container_for_delete_header {
      @include dialogTitle(#222);
    }
    .dialog_inner_container_for_delete_body {
      padding: 15px;
      text-align: center;
    }
    .dialog_inner_container_for_delete_footer {
      width: 100%;
      height: 70px;
      padding-bottom: 23px;
      @include verticalAndCrosswiseCenter();
      .dialog_inner_container_for_delete_footer_inner_item {
        width: 74px;
        height: 32px;
        @include verticalAndCrosswiseCenter();
        font-size: 12px;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
        box-shadow: 0 0 5px #f5f5f5;
        transition: all 0.5s;
        letter-spacing: 1px;
        &:nth-of-type(1) {
          &:hover {
            border: 1px solid #2090ff !important;
            color: #2090ff !important;
          }
        }
        &:nth-of-type(2) {
          &:hover {
            background-color: #48a2fc;
          }
        }
      }
    }
  }
  .icon_edit {
    font-size: 18px;
    color: rgba(105, 125, 142, 0.9);
    margin-right: 10px;
    vertical-align: -6px;
  }
}
</style>
